import { Component, Input, OnInit } from '@angular/core';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OptOutEnrollment } from '../../../shared/models/enrollment/opt-out-enrollment';
import { OpenEnrollment } from '../../../shared/models/enrollment/open-enrollment';
import { ConfirmedEnrollment } from '../../../shared/models/enrollment/confirmed-enrollment';
import { Member } from '../../../shared/models/enrollment/member';
import { PortalService } from '../../../core/services/portal.service';

@Component({
	selector: 'keep-plan',
	templateUrl: './keep-plan.component.html',
	styleUrls: ['./keep-plan.component.scss'],
	standalone: false
})
export class KeepPlanComponent extends AHSTripettoComponent implements OnInit {
	public members: Member[];
	public loaded: boolean = false;
	public selectForm: FormGroup;
	public oneMemberSelected: boolean = false;

	private selectedMembers = {
		verifyCommit: false,
		members: [] as Member[]
	};

	private subscriptions: Subscription[] = [];
	private setFromImport = false;

	@Input()
	oldForm?: FormGroup = null;

	constructor(
		private formBuilder: FormBuilder,
		private portalService: PortalService
	) {
		super();
	}

	ngOnInit(): void {
		this.members = [] as Member[];
		let data = undefined;

		if (this.scriptJsonStr) data = JSON.parse(this.scriptJsonStr);

		if (data) this.parseMembers(data[0]);

		// Sort the members array
		this.members.sort((a, b) => {
			// Put members who can keep the plan at the top
			if (a.canKeepPlan && !b.canKeepPlan) {
				return -1;
			} else if (!a.canKeepPlan && b.canKeepPlan) {
				return 1;
			}

			// Logic for isEligibleOnEffectiveDate
			if (a.isEligibleOnEffectiveDate && !b.isEligibleOnEffectiveDate) {
				return -1;
			} else if (!a.isEligibleOnEffectiveDate && b.isEligibleOnEffectiveDate) {
				return 1;
			} else {
				// Logic for sorting by age
				if (parseInt(a.recipientAge) > parseInt(b.recipientAge)) {
					return -1;
				} else if (parseInt(a.recipientAge) < parseInt(b.recipientAge)) {
					return 1;
				} else {
					// Logic for sorting by name
					if (a.fullName < b.fullName) {
						return -1;
					} else if (a.fullName > b.fullName) {
						return 1;
					} else {
						return 0;
					}
				}
			}
		});

		if (this.members) this.loaded = true;
	}

	private parseMembers(data: any) {
		const newConfirmed = [] as ConfirmedEnrollment[];

		data.confirmedEnrollmentsData?.forEach((element: ConfirmedEnrollment) => {
			newConfirmed.push(element);
		});

		data.eligibilityData.forEach((element) => {
			const newMember = {} as Member;

			newMember.recipientID = element.recipientID;
			newMember.fullName = element.fullName;
			newMember.dateOfBirth = element.dateOfBirth;
			newMember.recipientAge = element.recipientAge;
			newMember.enrollments = newConfirmed.filter((x) => x.recipientID == newMember.recipientID);
			newMember.canKeepPlan = element.canKeepPlan;
			newMember.selected = false;
			this.members.push(newMember);
		});
	}

	public entityChecked(checked: boolean, selectedMember: any): void {
		selectedMember.selected = checked;
		if (checked) {
			this.selectedMembers.members.push(selectedMember);
			this.oneMemberSelected = true;
		} else {
			const matchindex = this.selectedMembers.members.findIndex(
				(p) => p.recipientID == selectedMember.recipientID
			);

			if (matchindex > -1) {
				this.selectedMembers.members.splice(matchindex, 1);
			}
			//disable verify if no members
			if (this.selectedMembers.members.length < 1) {
				this.oneMemberSelected = false;
				this.selectedMembers.verifyCommit = false;
			}

			this.validate();
		}
	}
	public verifyCheckedfn(checked: boolean): void {
		this.selectedMembers.verifyCommit = checked;
		this.validate();
	}

	private validate() {
		if (this.oneMemberSelected == true && this.selectedMembers.verifyCommit == true) {
			this.setTripettoValue(JSON.stringify(this.selectedMembers));
		} else this.setTripettoValue(undefined);
	}

	public hasCurrentEnrollmentDate(enrollments: any[]): boolean {
		return enrollments.some((enroll) => enroll.currentEnrollmentDate);
	}
}
